import {RenderingServices, utils} from '@wallaby-ui/core';

export default function baseListFormatterItemParams(
  params,
  services: RenderingServices = {}
) {
  const {item} = params;
  const {intl} = services;

  const value = item.label || item.value;
  const label = intl ? utils.TranslateUtils.translate(value, intl) : value;

  let title =
    item.title && intl && utils.TranslateUtils.translate(item.title, intl);
  title = title || label;

  return {...params, title, label};
}
